import React from 'react'

import { Portlet, Button } from '_zari/core'
import { useHistory } from 'react-router-dom'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import ResumenGuias from 'partials/resumenGuias'

const VerDetallesPage = ({ match }) => {
  const portletBreadcrumbs = [{ name: 'Ver Detalles' }]

  const history = useHistory()

  const clickCerrarHandle = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.CONSULTAGUIAS_LISTA}`)
  }, [history])

  return (
    <Portlet>
      <Portlet.Header title='CONSULTA GUIAS' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <ResumenGuias id={match.params.id}></ResumenGuias>
      </Portlet.Body>
      <Portlet.Footer>
        <Button onClick={() => clickCerrarHandle()}>Cerrar</Button>
      </Portlet.Footer>
    </Portlet>
  )
}

export default VerDetallesPage
